import React, { useContext } from 'react';
import {
    ConfirmationModal,
    ConfirmationModalProps,
    useModal,
} from '@europrocurement/flexy-components';
import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router';
import { DossierRoutingContext } from '@europrocurement/l2d-modules';

const useDossierFormValidation = () => {
    const navigate = useNavigate();
    const { palette } = useTheme();
    const { modalActions } = useModal();
    const { getDossierRoute } = useContext(DossierRoutingContext);

    const persist = (): Promise<boolean> =>
        new Promise((resolve) => {
            const modalProps: ConfirmationModalProps = {
                messages: {
                    question: 'Souhaitez vous valider le(s) formulaire(s) ?',
                    detail: {
                        message: 'Êtes vous sur de vouloir sauvegarder ces changements',
                        severity: 'info',
                    },
                    validation: 'Sauvegarder',
                    annulation: 'Annuler',
                },
                actionOnValidation: () => {
                    modalActions.close();
                    resolve(true);
                },
                actionOnCancellation: () => {
                    modalActions.close();
                    resolve(false);
                },
                color: palette.primary,
                isFullWidth: true,
            };
            modalActions.call(<ConfirmationModal {...modalProps} />);
        });

    const persistAndUpdateStatus = (
        message: string = 'La validation du formulaire changera le statut en prêt à être déposé',
    ): Promise<boolean> =>
        new Promise((resolve) => {
            const modalProps: ConfirmationModalProps = {
                messages: {
                    question: 'Souhaitez vous valider le(s) formulaire(s) ?',
                    detail: {
                        message,
                        severity: 'info',
                    },
                    validation: 'Prêt à déposer',
                    annulation: 'Sauvegarder',
                },
                actionOnValidation: () => {
                    modalActions.close();
                    resolve(true);
                },
                actionOnCancellation: () => {
                    modalActions.close();
                    resolve(false);
                },
                color: palette.primary,
                isFullWidth: true,
            };
            modalActions.call(<ConfirmationModal {...modalProps} />);
        });

    const cancel = (dossierId: number) => {
        const modalProps: ConfirmationModalProps = {
            messages: {
                question: 'Êtes vous sûr de vouloir annuler ces changements ?',
                detail: {
                    message: 'Toutes les modifications non sauvegardées seront perdues',
                    severity: 'info',
                },
                validation: 'Oui',
                annulation: 'Non',
            },
            actionOnValidation: () => {
                navigate(getDossierRoute(dossierId));
                modalActions.close();
            },
            actionOnCancellation: () => {
                modalActions.close();
            },
            color: palette.warning,
            isFullWidth: true,
        };
        modalActions.call(<ConfirmationModal {...modalProps} />);
    };

    return { persist, persistAndUpdateStatus, cancel };
};

export default useDossierFormValidation;
